import React from "react";
import { Link } from "react-router-dom";
import { Exit } from "~misc/icons";

const RotaDoDiaDisclaimer = () => {
  return (
    <div
      data-testid="disclaimer-container"
      className="sticky top-0 bg-white z-[99] p-4 border-b-4 border-[#EEE] ml-[-1rem] mr-[-1rem]"
    >
      <div
        data-testid="disclaimer-inner-container"
        className="flex flex-col md:flex-row md:items-center md:justify-center max-w-[1280px] m-auto"
      >
        <Link to="/roteirizacao/mapa" data-testid="disclaimer-link" className="md:mr-auto md:ml-0 mx-auto mb-2 md:mb-0">
          <button data-testid="exit-button" className="md:mr-auto md:ml-0 mx-auto mb-2 md:mb-0 rotate-[-180deg]">
            <Exit />
          </button>
        </Link>
        <p data-testid="disclaimer-message" className="max-w-[800px] mx-auto text-center">
          <b>ATENÇÃO:</b> Você está navegando na opção de consulta de cliente, essa visita não será <b>contabilizada</b>
          .
        </p>
      </div>
    </div>
  );
};

export default RotaDoDiaDisclaimer;
